import { toast } from 'react-toastify';
import { logIt } from 'services/utils/logger';
import { encryptText } from 'services/utils/messaging/message.methods';
import { toastMsg } from 'services/utils/variables';
import { trackTrace, trackException } from 'TelemetryService';
import store from 'store';

export const chatOnReceiveCallback = function (options) {
  // dispatch
  let data = options.data;
  let channel = options.channel;
  if (channel === '/chatroom/' + options.chatId) {
    logIt('log', 'onMessageArrived', data);
    if (!data?.id || data.chatId == null) {
      const channels = window.RTC?.subscribedChannels || [];
      trackTrace(
        'incomplete chat payload in onReceive',
        {
          channel,
          callbackChatId: options.chatId,
          dataKeys:
            data && typeof data === 'object' ? Object.keys(data) : typeof data,
          rtcStatus: window.RTC?.status,
          rtcInit: window.RTC?.init,
          online: navigator.onLine,
          isChannelSubscribed: channels.includes(channel),
          isCallbackChatSubscribed: channels.includes(
            '/chatroom/' + options.chatId
          ),
          selectedChatId: window.GlobalSelectedId,
          subscribedCount: channels.length,
          data
        },
        2
      );
    }
    let mData = encryptText(data);
    options.onMessageArrived(mData, false);
  } else if (channel === '/chatroom/' + options.chatId + '/typing') {
    data.chatId = options.chatId;
    options.onTypingArrived(data, false);
  } else if (channel === '/chatroom/' + options.chatId + '/meta') {
    logIt('log', 'chatOnReceiveCallback::onMetaArrived', options);
    data.chatId = options.chatId;
    options.onMetaArrived(data);
  } else if (channel === '/chatroom/' + options.chatId + '/participants') {
    let chatData = {
      chatId: options.chatId,
      participants: data
    };
    options.onParticipantsChanged(chatData);
  } else if (
    channel ===
    '/chatroom/' + options.chatId + '/templatedquestions/answer'
  ) {
    options.onVisitorResponseArrivedForTemplatedQuestion(data);
  } else if (channel === '/chatroom/' + options.chatId + '/visitorattachment') {
    let chatData = {
      chatId: options.chatId,
      attachmentData: data
    };
    options.onVisitorAttachmentUpload(chatData);
  } else if (
    channel ===
    '/chatroom/' + options.chatId + '/questionattachment'
  ) {
    let chatData = {
      chatId: options.chatId,
      attachmentData: data
    };
    options.onOperatorAttachmentUpload(chatData);
  }
  // } else if (channel === '/chatroom/' + id + '/meta') {
  //     me.onMetaArrived(data);
  // } else if (channel === '/calls/chat/' + id) {
  //     me.onCallStatusArrived(data);
  // } else if (channel === '/chatroom/' + id + '/virtualassistant/ner') {
  //     me.onVirtualAssistantNERArrived(data);
  // } else if (channel === '/chatroom/' + id + '/templatedquestions/answer') {
  //     me.onVisitorResponseArrivedForTemplatedQuestions(data);
  // } else if (channel === '/chatroom/' + id + '/live') {
  //     //add chatId to argumnents
  //     if (data != undefined) {
  //         data.chatId = id;
  //     }
  //     me.onLiveArrived(data);
  // }
  // else if (channel === '/chatroom/' + id + '/realtime/text') {
  //     me.onRealtimeTextArrived(data);
  // }
  // else if (channel === '/chatroom/' + id + '/scriptsuggestion') {
  //     me.onScriptSuggestion(data);
  // }
};
export const chatOnSuccessCallback = function (args) {
  const meta = args?.meta;
  const {
    MessagingChats: { chats }
  } = store.getState();
  const chatId = meta?.room?.chatId;
  // UIUX-2218 - Need this flag to prevent lead notes duplication if chat already subscribed
  let isMessagesExist = false;
  if (chats && chatId && chats[chatId]) {
    let chat = chats[chatId];
    if (chat?.messages && chat.messages.length > 0) {
      isMessagesExist = true;
    }
  }
  const history = [];
  const source = meta?.history;
  if (Array.isArray(source)) {
    for (let i = 0; i < source.length; i++) {
      history.push(encryptText(source[i]));
    }
  }
  return { history, isMessagesExist, chatId };
};

export const chatOnPublishCallback = {
  onSuccess: args => {
    args.onMessageArrived(args.data, false);
  },
  onFailure: args => {
    if (window.navigator.onLine)
      alert(
        "We're sorry, there was a problem sending the message. The chat may no longer be active."
      );
    const errorMessage = args.getErrorMessage && args.getErrorMessage();
    logIt('Error', errorMessage);
    trackException(
      new Error(errorMessage || 'Publish to chatroom failed'),
      {
        online: window.navigator.onLine,
        errorMessage,
        channel: args?.channel,
        chatId: args?.data?.chatId
      }
    );
  }
};
